import { gql } from '@apollo/client';
import { VersionHistoryFields } from 'ants/query';

export const PlayerRankingReadQuery = gql`
  query PlayerRankingReadQuery(
    $resource: PlayerRankingInput!,
    $withHistory: Boolean
  ) {
    sports_cricket_player_ranking_read(
      resource: $resource,
      with_history: $withHistory
    ) {
      item {
        resource {
          account
          sport
          association
          gender
          format
          role
          key
          hashkey:_hashkey
        }
        ranks {
          player {
            account
            sport
            key
            hashkey: _hashkey
          }
          position
          changed_by
          team {
            account
            sport
            key
            hashkey: _hashkey
          }
          points
          ranking
        }
        updated_date {
          ranking_release_date
          ranking_recorded_date
          prev_ranking_release_date
          next_ranking_release_date
        }
        is_latest{
          is_latest
        }
        name {
          name
        }
        association
      }
      history {
        ${VersionHistoryFields}
      }
    }
  }
`;

export const PlayerRankingCreateFromExisitingMutation = gql`
  mutation PlayerRankingCreateFromExisitingMutation(
    $item: PlayerRankingInput!
  ) {
    sports_cricket_player_ranking_create_from_existing(
      item: $item,
    ) {
      item {
        account
        sport
        association
        gender
        format
        role
        key
        hashkey: _hashkey
    }
    status {
      okay
      errors {
        msg
        field_path
        code
      }
      key
    }
    }
  }
`;

export const PlayerRankingSearchQuery = gql`
  query PlayerRankingSearchQuery(
    $search: String!, 
    $page: PagedRequestInput
  ) {
    sports_cricket_player_ranking_search(
      search: $search,
      page: $page
    ) {
      items {
        item {
          account
          sport
          association
          gender
          format
          role
          key
          hashkey: _hashkey
        }
        association
        updated_date {
          ranking_recorded_date
          ranking_release_date
          next_ranking_release_date
          prev_ranking_release_date
        }
        is_latest {
          is_latest
          }
    }
    page {
      next_page_key
      count
      prev_page_key
    }
    top_counts {
      genders {
        key
        name
        count
      }
      associations {
        key
        name
        count
      }
      formats {
        key
        name
        count
      }
      roles {
        key
        name
        count
      }
    }
    }
  }
`;
export const PlayerRankingCreateMutation = gql`
  mutation PlayerRankingCreateMutation(
    $association: AssociationInput!,
    $gender: SportsGender!,
    $format: CricketMatchFormat!,
    $role: CricketPlayerRole,
  ) {
    sports_cricket_player_ranking_create(
      association: $association,
      gender: $gender,
      format: $format,
      role: $role,
    ) {
      item {
      account
      sport
      association
      gender
      format
      role
      _hashkey
    }
    status {
      okay
      errors {
        msg
        field_path
        code
      }
      key
    }
     
    is_similar_item
    }
  }
`;

export const PlayerRankingTopCountsQuery = gql`
  query PlayerRankingTopCountsQuery(
    $search: String!, 
    $page: PagedRequestInput,
    $filters: RankingsFiltersInput
  ) {
    sports_cricket_player_ranking_search(
      search: $search,
      page: $page,
      filters: $filters
    ) {
      top_counts {
      genders {
        key
        name
        count
      }
      associations {
        key
        name
        count
      }
      formats {
        key
        name
        count
      }
      roles {
        key
        name
        count
      }
    }
    }
  }
`;

export const PlayerRankingDeleteMutation = gql`
  mutation PlayerRankingDeleteMutation($resource: PlayerRankingInput!) {
    sports_cricket_player_ranking_delete(resource: $resource) {
      status {
        okay
        errors {
          msg
          field_path
          code
        }
        key
      }
    }
  }
`;

export const PlayerRankingUpdateMutation = gql`
  mutation PlayerRankingUpdateMutation(
    $resource: PlayerRankingInput!,
    $ranks: [PlayerRankingPlayerRankingInfoInput!]!,
    $updated_date: PlayerRankingUpdatedDateInput!,
    $version:RecordStage
  ) {
    sports_cricket_player_ranking_update(
      resource: $resource,
      ranks: $ranks,
      updated_date: $updated_date,
      version: $version
    ) {
      status {
      okay
      errors {
        msg
        field_path
        code
      }
      key
    }
    }
  }
`;
